import {Toaster as SonnerToaster} from 'sonner'
import {Icon} from 'components/elements/Icon'

export function Toaster() {
  return (
    <SonnerToaster
      position='top-right'
      richColors
      icons={{
        info: <Icon icon='info' />,
        success: <Icon icon='checkmark' />,
        warning: <Icon icon='warning' />,
        error: <Icon icon='error-8' />,
      }}
    />
  )
}
